import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FateDropdown } from 'fate-editor';

/**Componente per la dropdown delle citazioni dalla Mishna */
@Component({
  selector: 'app-mishna-dropdown',
  templateUrl: '../quote-template.html',
  styleUrls: ['../editor-dropdowns.css']
})
export class MishnaDropdownComponent implements FateDropdown {
  /**Input, la stringa eventualmente selezionata */
  @Input()
  public value: string;
  /**Emettitore per il valore selezionato dalla dropdown */
  @Output() public valueChange = new EventEmitter<string>();

  /**Elenco delle citazioni possibili */
  noteList = [
    {
      etichetta: '‘Arakhìn',
      valore: '<i>‘Arakhìn</i>'
    },
    {
      etichetta: '‘Avodà Zarà',
      valore: '<i>‘Avodà Zarà</i>'
    },
    {
      etichetta: '‘Eduyòt',
      valore: '<i>‘Eduyòt</i>'
    },
    {
      etichetta: '‘Eruvìn',
      valore: '<i>‘Eruvìn</i>'
    },
    {
      etichetta: '‘Oqatzìm',
      valore: '<i>‘Oqatzìm</i>'
    },
    {
      etichetta: '‘Orlà',
      valore: '<i>‘Orlà</i>'
    },
    {
      etichetta: 'Avòt',
      valore: '<i>Avòt</i>'
    },
    {
      etichetta: 'Bavà Batrà',
      valore: '<i>Bavà Batrà</i>'
    },
    {
      etichetta: 'Bavà Metzi‘à',
      valore: '<i>Bavà Metzi‘à</i>'
    },
    {
      etichetta: 'Bavà Qammà',
      valore: '<i>Bavà Qammà</i>'
    },
    {
      etichetta: 'Bekhoròt',
      valore: '<i>Bekhoròt</i>'
    },
    {
      etichetta: 'Berakhòt',
      valore: '<i>Berakhòt</i>'
    },
    {
      etichetta: 'Betzà',
      valore: '<i>Betzà</i>'
    },
    {
      etichetta: 'Bikkurìm',
      valore: '<i>AvòBikkurìmt</i>'
    },
    {
      etichetta: 'Chaghigà',
      valore: '<i>Chaghigà</i>'
    },
    {
      etichetta: 'Challà',
      valore: '<i>Challà</i>'
    },
    {
      etichetta: 'Chullìn',
      valore: '<i>Chullìn</i>'
    },
    {
      etichetta: 'Demài',
      valore: '<i>Demài</i>'
    },
    {
      etichetta: 'Ghittìn',
      valore: '<i>Ghittìn</i>'
    },
    {
      etichetta: 'Horayòt',
      valore: '<i>Horayòt</i>'
    },
    {
      etichetta: 'Kelìm',
      valore: '<i>Kelìm</i>'
    },
    {
      etichetta: 'Keritòt',
      valore: '<i>Keritòt</i>'
    },
    {
      etichetta: 'Ketubbòt',
      valore: '<i>Ketubbòt</i>'
    },
    {
      etichetta: 'Kilàim',
      valore: '<i>Kilàim</i>'
    },
    {
      etichetta: 'Ma‘asèr Shenì',
      valore: '<i>Ma‘asèr Shenì</i>'
    },
    {
      etichetta: 'Ma‘asròt',
      valore: '<i>Ma‘asròt</i>'
    },
    {
      etichetta: 'Makhshirìn',
      valore: '<i>Makhshirìn</i>'
    },
    {
      etichetta: 'Makkòt',
      valore: '<i>Makkòt</i>'
    },
    {
      etichetta: 'Me‘ilà',
      valore: '<i>Me‘ilà</i>'
    },
    {
      etichetta: 'Meghillà',
      valore: '<i>Meghillà</i>'
    },
    {
      etichetta: 'Menachòt',
      valore: '<i>Menachòt</i>'
    },
    {
      etichetta: 'Middòt',
      valore: '<i>Middòt</i>'
    },
    {
      etichetta: 'Miqwaòt',
      valore: '<i>Miqwaòt</i>'
    },
    {
      etichetta: 'Mo‘èd Qatàn',
      valore: '<i>Mo‘èd Qatàn</i>'
    },
    {
      etichetta: 'Nazìr',
      valore: '<i>Nazìr</i>'
    },
    {
      etichetta: 'Nedarìm',
      valore: '<i>Nedarìm</i>'
    },
    {
      etichetta: 'Nega‘ìm',
      valore: '<i>Nega‘ìm</i>'
    },
    {
      etichetta: 'Niddà',
      valore: '<i>Niddà</i>'
    },
    {
      etichetta: 'Ohalòt',
      valore: '<i>Ohalòt</i>'
    },
    {
      etichetta: 'Parà',
      valore: '<i>Parà</i>'
    },
    {
      etichetta: 'Peà',
      valore: '<i>Peà</i>'
    },
    {
      etichetta: 'Pesachìm',
      valore: '<i>Pesachìm</i>'
    },
    {
      etichetta: 'Qiddushìn',
      valore: '<i>Qiddushìn</i>'
    },
    {
      etichetta: 'Qinnìm',
      valore: '<i>Qinnìm</i>'
    },
    {
      etichetta: 'Rosh haShanà',
      valore: '<i>Rosh haShanà</i>'
    },
    {
      etichetta: 'Sanhedrìn',
      valore: '<i>Sanhedrìn</i>'
    },
    {
      etichetta: 'Shabbàt',
      valore: '<i>Shabbàt</i>'
    },
    {
      etichetta: 'Sheqalìm',
      valore: '<i>Sheqalìm</i>'
    },
    {
      etichetta: 'Shevi‘ìt',
      valore: '<i>Shevi‘ìt</i>'
    },
    {
      etichetta: 'Shevu‘òt',
      valore: '<i>Shevu‘òt</i>'
    },
    {
      etichetta: 'Sotà',
      valore: '<i>Sotà</i>'
    },
    {
      etichetta: 'Sukkà',
      valore: '<i>Sukkà</i>'
    },
    {
      etichetta: 'Ta‘anìt',
      valore: '<i>Ta‘anìt</i>'
    },
    {
      etichetta: 'Tahoròt',
      valore: '<i>Tahoròt</i>'
    },
    {
      etichetta: 'Tamìd',
      valore: '<i>Tamìd</i>'
    },
    {
      etichetta: 'Temurà',
      valore: '<i>Temurà</i>'
    },
    {
      etichetta: 'Terumòt',
      valore: '<i>Terumòt</i>'
    },
    {
      etichetta: 'Tevùl Yom',
      valore: '<i>Tevùl Yom</i>'
    },
    {
      etichetta: 'Yadàim',
      valore: '<i>Yadàim</i>'
    },
    {
      etichetta: 'Yevamòt',
      valore: '<i>Yevamòt</i>'
    },
    {
      etichetta: 'Yomà',
      valore: '<i>Yomà</i>'
    },
    {
      etichetta: 'Zavìm',
      valore: '<i>Zavìm</i>'
    },
    {
      etichetta: 'Zevachìm',
      valore: '<i>Zevachìm</i>'
    }
  ];

  /**Indice elemento selezionato */
  public selected = 0;

  /**
   * Metodo che gestisce l'emissione del valore selezionato
   * @param value {any} il valore selezionato
   */
  public changeValue(value) {
    this.valueChange.emit(value);
  }

  /**Metodo che gestisce la selezione del successivo */
  public selectNext() {
    this.selected++;
    if (this.selected >= this.noteList.length) {
      this.selected = this.noteList.length - 1;
    }
  };
  /**Metodo che gestisce la selezione del precedente */
  public selecPrevious() {
    this.selected--;
    if (this.selected < 0) {
      this.selected = 0;
    }
  };
  /**Metodo che conferma la selezione lanciando il metodo di cambio valore */
  public confirmSelection() {
    this.changeValue(this.noteList[this.selected]);
  };
  constructor() { }

}
